import routes from '@routes';
import { ADMIN_PORTAL_QP, ENTER_MFA_PARAM } from './interfaces.ts';

const VITE_PORTAL_URL = import.meta.env.VITE_PORTAL_URL;

const openPortalLink = (path?: string) => {
  let url = VITE_PORTAL_URL;

  if (path) {
    if (!path.startsWith('/')) {
      path = '/' + path;
    }

    url += path;
  }

  window.open(url, '_blank');
};

export const showAdminPortal = (path?: string) => {
  if (path) {
    return openPortalLink(`?${ADMIN_PORTAL_QP}=${path}`);
  }

  openPortalLink();
};

export const onSetUpMfa = () => {
  openPortalLink(`${routes.OpenRequests.path}?${ADMIN_PORTAL_QP}=/admin-box/privacy`);
};

export const onEnterMfa = () => {
  openPortalLink(`${routes.OpenRequests.path}?${ENTER_MFA_PARAM}=true`);
};

export const switchTenant = () => {};

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
